import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const FlaggedArtist = ({id, is_flagged, tooltipPlacement="top"}) => {
  const { t } = useTranslation();
  const tooltipId = `flag-tooltip-${id}`;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const tooltipText = is_flagged
    ? t('artists.view.table.message.artistFlagged')
    : t('artists.view.table.message.artistNotFlagged');
  const iconColor = is_flagged ? 'danger' : 'success';

  return (
    <div 
        key={id}
        id={tooltipId}
        className={`mdi mdi-flag mdi-36px text-${iconColor}`}
        style={{ cursor: 'pointer' }}
    >
      <Tooltip
        placement={tooltipPlacement}
        isOpen={tooltipOpen}
        target={tooltipId}
        toggle={toggle}
      >
        {tooltipText}
      </Tooltip>
    </div>
  );
};

export default FlaggedArtist;